export default __webpack_public_path__ + "static/media/loading-register.72371974.png";